<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <!-- <a href="/home"> -->
    <div class="logo" [routerLink]="linkHomePage">
        <img class="logo-icon" [src]="rutaLogo">
        <span class="logo-text secondary-text">{{titutloCGO}}</span>
    </div>
    <!-- </a> -->

    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground" fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
        <div class="h3 username">{{datosUsuario.nombre}}</div>
        <div class="h5 email hint-text mt-8">{{datosUsuario.email}}</div>
        <div class="avatar-container" *ngIf="puedeCargarLogo" [ngClass]="fuseConfig.layout.navbar.primaryBackground" (click)="fileInput.click()" matTooltip="{{'LOGIN.FORM.CAMBIALOGO' | translate}}">
            <mat-icon class="secondary-text logoNuevo">add_a_photo</mat-icon>
            <!-- <input id="inputImagen" hidden type="file" #fileInput (change)="cambiarImagen($event)"> -->
            <input id="inputImagen" type="file" (change)="cargarImagenNueva($event)" accept="image/*" #fileInput hidden>
            <img class="avatar" src="{{rutaimagen}}">
        </div>
        <div class="avatar-container" *ngIf="!puedeCargarLogo" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="{{rutaimagen}}">
        </div>

    </div>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
        <ng-container *ngIf="infoCargado">
        <a *ngIf="instituto=='1' && datosUsu.level!=4" id="contact" href="mailto:mx_transparencia@greatplacetowork.com" title="mx_transparencia@greatplacetowork.com" mat-button>{{'NAV.CONTACTO.TITULO' | translate}}</a>
        <a *ngIf="instituto=='1' && datosUsu.level!=4" id="contactIcon" href="mailto:mx_transparencia@greatplacetowork.com" title="mx_transparencia@greatplacetowork.com" mat-button>
            <mat-icon>alternate_email</mat-icon>
        </a>
      </ng-container>

        <a *ngIf="instituto=='15'" id="contact" href="mailto:ES_info@greatplacetowork.com" title="ES_info@greatplacetowork.com" mat-button>{{'NAV.CONTACTO.TITULO' | translate}}</a>
        <a *ngIf="instituto=='15'" id="contactIcon" href="mailto:ES_info@greatplacetowork.com" title="ES_info@greatplacetowork.com" mat-button>
            <mat-icon>alternate_email</mat-icon>
        </a>
    </div>

</div>
